import React from 'react';
import {Box} from '@mui/material';
import ComponentContainer from './atoms/ComponentContainer';
import RandomImagesComponent from './atoms/RandomImages';
import type { RandomImages as RandomImagesProps } from '../types/app';

const MAX_IMAGES_PER_ROW = 6; // Define your desired maximum number of images per row

const calculateGridColumns = (totalImages: number) => {
    if (totalImages <= MAX_IMAGES_PER_ROW) {
        return 12 / totalImages;        // Ensure that the total width of the row is 12
    } else {
        return 12 / MAX_IMAGES_PER_ROW; // Use the maximum number of images per row
    }
};

export const RandomImages = (props: RandomImagesProps) => (
    <ComponentContainer fullWidth={true} contentful_id={props.contentful_id}  sx={{pt:'0px!important',m:0,p:0}}>
        <Box data-sb-field-path="quantity">
            <RandomImagesComponent 
                seed        = {props.contentful_id}
                imageSet    = {props.imageSet} 
                count       = {props?.quantity} 
                xs          = {calculateGridColumns(props?.quantity)}
            />
        </Box>
    </ComponentContainer>
);

export default RandomImages;
